import styled from 'styled-components';

const DocFiles = styled.div`
  display: flex;
  flex-direction: column;
  font-size: var(--font-size-xs);
`;

export default DocFiles;
